// extracted by mini-css-extract-plugin
module.exports = {"ScrollView":"Scroller_ScrollView__13W_e","Zoom":"Scroller_Zoom__Vt34j"};